import { render, staticRenderFns } from "./MinimalisticDropdown.vue?vue&type=template&id=747c2323&scoped=true&lang=pug&"
import script from "./MinimalisticDropdown.vue?vue&type=script&lang=ts&"
export * from "./MinimalisticDropdown.vue?vue&type=script&lang=ts&"
import style0 from "./MinimalisticDropdown.vue?vue&type=style&index=0&id=747c2323&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "747c2323",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\as3-portals\\AS3.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('747c2323')) {
      api.createRecord('747c2323', component.options)
    } else {
      api.reload('747c2323', component.options)
    }
    module.hot.accept("./MinimalisticDropdown.vue?vue&type=template&id=747c2323&scoped=true&lang=pug&", function () {
      api.rerender('747c2323', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/components/MinimalisticDropdown.vue"
export default component.exports